import {BlockedDayData, CalendarEventData} from '../../generated/dto';
import {EventInput} from '@fullcalendar/react';

export function getFirstDayOfWeek(d: Date) {
  const date = new Date(d);
  const day = date.getDay();

  const diff = date.getDate() - day + (day === 0 ? -6 : 1);

  return new Date(date.setDate(diff));
}

export function getYearMonthInExchangeFormat(date: Date): string {
  const year = date.getFullYear();
  let month = (date.getMonth() + 1).toString();
  if (parseInt(month) < 10) {
    month = '0' + month;
  }

  return `${year}-${month}`;
}

export function getFullDateInExchangeFormat(date: Date): string {
  const year = date.getFullYear();
  let month = (date.getMonth() + 1).toString();
  if (parseInt(month, 10) < 10) {
    month = '0' + month;
  }
  let day = date.getDate().toString();
  if (parseInt(day, 10) < 10) {
    day = '0' + day;
  }

  return `${year}-${month}-${day}`;
}

export function transformEventsToEventInput(
  calendarEvents: Array<CalendarEventData>,
  colorOverride = ''
): EventInput[] {
  const events: EventInput[] = [];

  calendarEvents.map((entry) => {
    entry.occurrences.map((occurrence, index) => {
      const newEvent: EventInput = {
        color: entry.event.color,
        end: occurrence.to,
        url: entry.event.href,
        start: occurrence.from,
        title: entry.event.name,
        id: index.toString(10)
      };

      if (!occurrence.is_available) {
        newEvent.title += ' (ausgebucht)';
      }

      if (colorOverride) {
        newEvent.color = colorOverride;
      }

      events.push(newEvent);
    });
  });

  return events;
}

export function transformBlockedDaysToEventInput(
  blockedDays: Array<BlockedDayData>,
  colorOverride = ''
): EventInput[] {
  const events: EventInput[] = [];

  blockedDays.map((blockedDay) => {
    const newEvent: EventInput = {
      title: blockedDay.name ?? '',
      start: blockedDay.from,
      end: blockedDay.to
    };

    if (colorOverride) {
      newEvent.color = colorOverride;
    }

    events.push(newEvent);
  });

  return events;
}
